import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import RepairLogEntryForm from './RepairLogEntryForm';
import * as repairLogEntryActions from '../../actions/repairLogEntryActions';
import { toast } from 'react-toastify';
import { Row, Col } from 'reactstrap';
import { loadLimitedUsers } from '../../actions/userActions';
import ImageViewer from '../common/ImageViewer';
import { hasRole } from '../../services/authService';
import BillingItemList from './BillingItemList';

class ManageRepairLogEntryPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      entry: Object.assign({}, props.currentEntry),
      errors: {},
      saving: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.currentEntry) {
      if (this.props.currentEntry.id !== nextProps.currentEntry.id) {
        this.setState({
          currentEntry: Object.assign({}, nextProps.currentEntry),
        });
      }
    }
  }

  componentWillMount() {
    if (!this.props.users.length > 0) this.props.actions.loadLimitedUsers();
  }

  formIsValid() {
    const { entry } = this.state;
    let errors = {};
    let isValid = true;

    if (entry.hoursTaken < 0) {
      errors.hoursTaken = 'Time must more than 0 hours.';
      isValid = false;
    }
    if (entry.location === '') {
      errors.location = 'Enter address or location of work.';
      isValid = false;
    }
    if (entry.description === '') {
      errors.description = 'Please enter a description of the work performed';
      isValid = false;
    }

    this.setState({ errors: errors });
    return isValid;
  }

  saveEntry = (event) => {
    event.preventDefault();
    if (!this.formIsValid()) return;
    this.setState({ saving: true });
    let { entry } = this.state;
    entry.userId = entry.userId || this.props.currentUser.id;
    const logId = this.props.logId;
    this.props.actions
      .saveRepairLogEntry(entry, logId)
      .then(() => this.redirectSuccess('Entry saved'))
      .catch((error) => {
        toast.error(error);
        this.setState({ saving: false });
      });
  };

  deleteEntry = (event) => {
    event.preventDefault();
    this.setState({ saving: true });
    this.props.actions
      .deleteRepairLogEntry(this.state.entry)
      .then(() => this.redirectSuccess('Entry deleted'))
      .catch((error) => {
        toast.error(error);
        this.setState({ saving: false });
      });
  };

  redirectSuccess(msg) {
    this.setState({ saving: false });
    toast.success(msg);
    this.props.history.push('/repair-log/' + this.props.currentEntry.logId);
  }

  updateEntryState = (event) => {
    const field = event.target.id;
    let entry = Object.assign({}, this.state.entry);
    entry[field] = event.target.value;
    this.setState({ entry: entry });
  };

  render() {
    return (
      <div>
        <Row>
          <Col md={12}>
            <h1 className="text-center my-4">Manage Repair Log Entry</h1>
          </Col>
        </Row>
        <RepairLogEntryForm
          logEntry={this.state.entry}
          onChange={this.updateEntryState}
          onSave={this.saveEntry}
          saving={this.state.saving}
          onDelete={this.deleteEntry}
          errors={this.state.errors}
          user={
            this.props.users.filter(
              (u) => u.id === this.props.currentEntry.userId
            )[0]
          }
        />
        {
          <Row>
            <ImageViewer className={'px-2'} entryId={this.state.entry.id} />
          </Row>
        }
        {hasRole('ROLE_MANAGER') && (
          <Row>
            <BillingItemList entryId={this.state.entry.id} />
          </Row>
        )}
      </div>
    );
  }
}

ManageRepairLogEntryPage.propTypes = {
  actions: PropTypes.object.isRequired,
};

function getEntryById(entries, id) {
  const entry = entries.filter((entry) => entry.id === id);
  if (entry) return entry[0];
  return null;
}

function mapStateToProps(state, ownProps) {
  const id = ownProps.match.params.id;
  const entryId = Number.parseInt(id, 10);
  const logId = Number.parseInt(ownProps.match.params.logId, 10);

  let currentEntry = {
    id: '',
    logId: logId,
    hoursTaken: '',
    location: '',
    description: '',
    userId: state.currentUser.id,
  };

  if (entryId && state.repairLogEntries.length > 0) {
    currentEntry = getEntryById(state.repairLogEntries, entryId);
  }

  return {
    currentEntry: currentEntry,
    users: state.users,
    currentUser: state.currentUser,
    logId: logId,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...repairLogEntryActions, loadLimitedUsers },
      dispatch
    ),
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ManageRepairLogEntryPage)
);



// WEBPACK FOOTER //
// ./src/components/repair-log/ManageRepairLogEntryPage.js